import { useEffect, useState } from 'react';

import { MagicWandSvg } from '../../../../assets/icons/MagicWandSvg';
import theme from '../../../../assets/theme';
import {
  TemplateStateActions,
  useDesignerDataContext,
} from '../../../../hooks/useDesignerLogic';
import {
  DesignerUIStateActions,
  useDesignerUIContext,
} from '../../../../hooks/useDesignerUIState';
import { PromptSingleTestCaseResult } from '../../../../services/backendService/types';
import { Button } from '../../../_atoms/Button';
import { IconWrapper } from '../../../_atoms/IconWrapper';
import BaseModal from '../../../_molecules/BaseModal';
import SearchInput from '../../../_molecules/SearchInput';

export const PromptAIConnector = ({ promptSourceId }: { promptSourceId: string }) => {
  const dispatch = useDesignerUIContext(context => context.dispatch);

  const selectedPromptSourceId = useDesignerUIContext(
    c => c.state.aiConnection?.promptSourceId,
  );

  return (
    <IconWrapper
      style={{
        borderRadius: 50,
        width: 20,
        height: 20,
        border:
          selectedPromptSourceId === promptSourceId
            ? '1px solid transparent'
            : '1px solid black',
        padding: 3,
        background:
          selectedPromptSourceId === promptSourceId ? theme.colors.purple : undefined,
        color: selectedPromptSourceId === promptSourceId ? theme.colors.white : undefined,
      }}
      onClick={() => {
        if (selectedPromptSourceId === promptSourceId) {
          dispatch({ type: DesignerUIStateActions.resetAIConnection });
        } else {
          dispatch({
            type: DesignerUIStateActions.setAITextPromptSourceId,
            promptSourceId,
          });
        }
      }}
      height="14px"
      width="14px"
    >
      <MagicWandSvg />
    </IconWrapper>
  );
};

export const AIConnectorConfirmModal = ({
  promptResult,
}: {
  promptResult?: PromptSingleTestCaseResult;
}) => {
  const aiConnection = useDesignerUIContext(context => context.state.aiConnection);

  const isOpen = !!aiConnection?.promptSourceId && !!aiConnection?.aiTextElementId;

  const dispatch = useDesignerUIContext(context => context.dispatch);

  const dataDispatch = useDesignerDataContext(context => context.dispatch);

  const [exampleText, setExampleText] = useState<string>('');

  const handleConfirm = () => {
    if (aiConnection?.promptSourceId && aiConnection?.aiTextElementId) {
      dataDispatch({
        type: TemplateStateActions.convertTextElementToAITextElement,
        promptSourceId: aiConnection?.promptSourceId,
        elementId: aiConnection?.aiTextElementId,
        isPollOption: aiConnection?.isPollOption,
        exampleText,
      });
      dispatch({ type: DesignerUIStateActions.resetAIConnection });
      dispatch({ type: DesignerUIStateActions.deselectElements });
    }
  };

  useEffect(() => {
    if (promptResult && aiConnection?.promptSourceId && aiConnection.aiTextElementId) {
      setExampleText(promptResult[aiConnection?.promptSourceId || '']?.value || '');
    }
  }, [isOpen, promptResult, aiConnection]);

  return (
    <BaseModal
      onCancel={() => {
        dispatch({ type: DesignerUIStateActions.resetAIConnection });
      }}
      title={`Connect and fill with example?`}
      visible={isOpen}
    >
      <div>
        <span>Example text</span>
        <SearchInput
          icon={null}
          value={exampleText}
          style={{ width: '100%', marginBottom: '20px' }}
          onChange={val => setExampleText(val)}
        />
        <Button onClick={() => handleConfirm()}>Connect and fill</Button>
      </div>
    </BaseModal>
  );
};
